
<template>
    <div>
        <h2>后勤价值年度目标</h2>
        <span>填报指引：医院按后勤价值型管理方案要求明确年度工作总目标，通过分别量化设定医院年度后勤经营效益，最终设定后勤管理价值年度目标值。</span><br>

        <h5>成本节余项</h5>
         <el-form :model="costData" ref="costDataRef">
            <el-table :data="costData" style="" class="table1"  >
                    <el-table-column
                        prop="typeName"
                        label="类别"
                        width="180"   
                        >
                        <template slot-scope="scope">
                            <el-form-item :prop="scope.$index+'.typeName'" :rules="[
                            { required: true, message: '必填', trigger: 'blur' }
                            ]">
                            <el-input v-model="scope.row.typeName" placeholder="请输入内容" disabled ></el-input>
                            </el-form-item>
                            <div class="block"></div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="itemId"
                        label="科目"
                        width="180">
                        <template slot-scope="scope">
                         <el-form-item :prop="scope.$index+'.itemId'" :rules="[
                            { required: true, message: '必填', trigger: 'change' }
                            ]">
                             <el-select v-model="scope.row.itemId" placeholder="请选择" @change="((val)=>{return itemIdSelect(val,costItems,costData)})">
                                <el-option
                                v-for="item in costItems"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                                :disabled="item.disabled">
                                </el-option>
                            </el-select>
                            </el-form-item>
                            <div class="block"></div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="lastTarget"
                        label="上年度数据（万元）"
                        width="180">
                        <template slot-scope="scope">
                            <el-form-item :prop="scope.$index+'.lastTarget'" :rules="[
                            { required: true, message: '必填', trigger: 'blur' },
                            rule1
                            ]">
                           <el-input v-model="scope.row.lastTarget" placeholder="请输入内容" @blur="computeValue(scope.row)" ></el-input>
                            </el-form-item>
                            <div class="block"></div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="currentTarget"
                        label="本年度目标（万元）"
                        width="180">
                        <template slot-scope="scope">
                            <el-form-item :prop="scope.$index+'.currentTarget'" :rules="[
                            { required: true, message: '必填', trigger: 'blur' },
                            rule1
                            ]">
                             <el-input v-model="scope.row.currentTarget"  placeholder="请输入内容" @blur="computeValue(scope.row)" ></el-input>
                            </el-form-item>
                            <div class="block"></div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="valueCreate"
                        label="价值创造（万元）"
                        width="180">
                        <template slot-scope="scope">
                             <el-form-item :prop="scope.$index+'.valueCreate'" >
                             <el-input v-model="scope.row.valueCreate" placeholder="请输入内容" disabled></el-input>
                            </el-form-item>
                            <div class="block"></div>         
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop=""
                        label="操作"
                        width="100">
                        <template slot-scope="scope" v-if='costData.length>1'>
                            <el-button @click="remove(costData,scope.row.index,costItems,scope.row.itemId)" >删除</el-button>
                        </template>
                    </el-table-column>
            </el-table>
         </el-form>
    <div>
        <button class="btn" @click="add(costData)">+</button>
    </div>
    <h5>创收增效项</h5>
     <el-form :model="revenueData" ref="revenueDataRef" >
                     <el-table :data="revenueData" style="" class="table1" >
                    <el-table-column
                        prop="typeName"
                        label="类别"
                        width="180"   
                        >
                        <template slot-scope="scope">
                            <el-form-item :prop="scope.$index+'.typeName'" :rules="[
                            { required: true, message: '必填', trigger: 'blur' }
                            ]">
                            <el-input v-model="scope.row.typeName" placeholder="请输入内容"  disabled></el-input>
                            </el-form-item>
                            <div class="block"></div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="itemId"
                        label="科目"
                        width="180">
                        <template slot-scope="scope">
                         <el-form-item :prop="scope.$index+'.itemId'" :rules="[
                            { required: true, message: '必填', trigger: 'change' }
                            ]">
                          <el-select v-model="scope.row.itemId" placeholder="请选择" @change="((val)=>{return itemIdSelect(val,valueItems,revenueData)})">
                                <el-option
                                v-for="item in valueItems"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                                :disabled="item.disabled">
                                </el-option>
                            </el-select>
                            </el-form-item>
                            <div class="block"></div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="lastTarget"
                        label="上年度数据（万元）"
                        width="180">
                        <template slot-scope="scope">
                            <el-form-item :prop="scope.$index+'.lastTarget'" :rules="[
                            { required: true, message: '必填', trigger: 'blur' },
                            rule1
                            ]">
                           <el-input v-model="scope.row.lastTarget" placeholder="请输入内容" @blur="computeValue1(scope.row)"> </el-input>
                            </el-form-item>
                            <div class="block"></div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="currentTarget"
                        label="本年度目标（万元）"
                        width="180">
                        <template slot-scope="scope">
                            <el-form-item :prop="scope.$index+'.currentTarget'" :rules="[
                            { required: true, message: '必填', trigger: 'blur' },
                            rule1
                            ]">
                             <el-input v-model="scope.row.currentTarget" placeholder="请输入内容" @blur="computeValue1(scope.row)"></el-input>
                            </el-form-item>
                            <div class="block"></div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="valueCreate"
                        label="价值创造（万元）"
                        width="180">
                        <template slot-scope="scope">
                             <el-form-item :prop="scope.$index+'.valueCreate'" >
                             <el-input v-model="scope.row.valueCreate" placeholder="请输入内容" disabled></el-input>
                            </el-form-item>
                            <div class="block"></div>         
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop=""
                        label="操作"
                        width="100">
                        <template slot-scope="scope" v-if='revenueData.length>1'>
                              <el-button @click="remove(revenueData,scope.row.index,valueItems,scope.row.itemId)" >删除</el-button>
                        </template>
                    </el-table-column>
            </el-table>
         </el-form>
    <div>
        <button class="btn" @click="add(revenueData)">+</button>
    </div>
    <el-form :model="form"  :rules="costForm" ref="costFormRef"  class="demo-only" style="margin-top:10px" > 
        <el-col :span='6'>
            <el-form-item label="成本来源" prop='costSource' >
                <el-select v-model="form.costSource" placeholder="请选择成本来源" >
                     <el-option
                v-for="item in costSourceItems"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
                     </el-option>
                </el-select>
            </el-form-item> 
        </el-col>
        <el-col :span='5'>
            <el-form-item label="成本基数" width="120" prop="costBasis">
                <el-input v-model="form.costBasis"></el-input>
            </el-form-item> 
        </el-col>
       <el-col :span="1"><span style="height: 32px;display: block;line-height: 32px;">万元</span></el-col>
        <el-col :span='5'>
            <el-form-item label="成本目标" width="120" prop="targetCost">
                <el-input v-model.trim="form.targetCost" disabled></el-input>
            </el-form-item>
            
        </el-col>
        <el-col :span="1"><span style="height: 32px;display: block;line-height: 32px;" >万元</span></el-col>
        <el-col :span='5'>
            <el-form-item label="创收目标" width="120" prop="targetIncome">
                <el-input v-model="form.targetIncome" disabled></el-input>
            </el-form-item> 
        </el-col>
        <el-col :span="1"><span style="height: 32px;display: block;line-height: 32px;">万元</span></el-col>
    </el-form>
    </div>
</template>
<script>
import { getValueItem, saveValueTarget } from '@/api/crmedical/value/valuebudget';
import { getDictionaryWithIntKey } from '@/api/common';
export default {
  props: {
    editDetailInfo: {},
  },
  data() {
    var validatePass = (rule, value, callback) => {
      let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error('输入格式不正确'));
      }
    };
    return {
      rule1: { validator: validatePass, trigger: 'blur' },
      refList: ['costDataRef', 'revenueDataRef', 'costFormRef'],
      validateFlag: false, //表单验证状态
      form: {
        targetCost: '', //成本目标
        targetIncome: '', //创收目标
        costSource: '', //成本来源
        costBasis: '', //成本基数
      },
      costItems: [],//成本下拉框
      valueItems: [],//创收价值框
      addForm: {
        typeName: '',
        itemId: '',
        lastTarget: '',
        currentTarget: '',
        valueCreate: '',
        index: 0,
        regShow: false,
      },
      costData: [
        {
          typeName: '成本',
          itemId: '',
          lastTarget: '',
          currentTarget: '',
          valueCreate: '',
          index: 0,
          regShow: false,
        },
      ],
      revenueData: [
        {
          typeName: '创收',
          itemId: '',
          lastTarget: '',
          currentTarget: '',
          valueCreate: '',
          index: 0,
        },
      ],
      ruleForm: {
        typeName: [],
        itemId: [{ required: true, message: '请选择科目', trigger: 'blur' }],
        lastTarget: [{ required: true, message: '请输入上年度数据', trigger: 'blur' }],
        currentTarget: [{ required: true, message: '请输入本年度目标', trigger: 'blur' }],
        valueCreate: [],
      },
      costForm: {
        costSource: [{ required: true, message: '请输入成本来源', trigger: 'change' }],
        costBasis: [
          { required: true, message: '请输入成本基数', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' },
        ],
        targetCost: [
         
        ],
        targetIncome: [
         
        ],
      },
      costSourceItems: [],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    //成本价值自动计算
    computeValue(data) {
      let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
      if (data.lastTarget && data.currentTarget&&reg.test(data.lastTarget)&&reg.test(data.currentTarget)) {
        data.valueCreate = (data.lastTarget - data.currentTarget).toFixed(2);
      }
      let targetCost = 0
      //计算总目标
      this.costData.forEach(item =>{
        targetCost+=Number(item.currentTarget)
      })
      this.form.targetCost = targetCost.toFixed(2)

    },
    //创收价值自动计算
    computeValue1(data) {
      let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
      if (data.lastTarget && data.currentTarget&&reg.test(data.lastTarget)&&reg.test(data.currentTarget)){
        data.valueCreate = (data.currentTarget - data.lastTarget).toFixed(2);
      }
      //计算总目标
      let targetIncome = 0
      this.revenueData.forEach(item =>{
        targetIncome+=Number(item.currentTarget)
      })
      this.form.targetIncome =targetIncome.toFixed(2)
    },
    async initData() {
      //成本科目
      await getValueItem(1).then(({ data }) => {
        this.costItems = data;
      });
      //创收科目
      await getValueItem(2).then(({ data }) => {
        this.valueItems = data;
      });

      await getDictionaryWithIntKey('value_cost_source').then((data) => {
        this.costSourceItems = data.data;
      });
      let arry = this.editDetailInfo['annuals'];
      for (const key in this.form) {
        if(this.editDetailInfo[key]){
          this.form[key] = this.editDetailInfo[key];
        }
        
      }
      let costData = [],
        revenueData = [];
      if (arry && arry.length > 0) {
        arry.forEach((item) => {
          if (item.itemType == 1) {
            //处理下拉框的值
            this.costItems.forEach((costItem) => {
              if (costItem.id == item.itemId) {
                this.$set(costItem, 'disabled', true);
              }
            });
            item.index = costData.length;
            costData.push(item);
          } else {
            this.valueItems.forEach((valueItem) => {
              if (valueItem.id == item.itemId) {
                this.$set(valueItem, 'disabled', true);
              }
            });
            item.index = revenueData.length;
            revenueData.push(item);
          }
        });
      }

      this.costData = costData.length > 0 ? costData : this.costData;
      this.revenueData = revenueData.length > 0 ? revenueData : this.revenueData;
    },
    itemIdSelect(e, selectData, tableData) {
      let selectedArray = [];
      tableData.forEach((item) => {
        if (item != '') {
          selectedArray.push(item.itemId);
        }
      });
      selectData.forEach((item) => {
        item.disabled = false;
      });
      for (let j = 0; j < selectData.length; j++) {
        for (let i = 0; i < selectedArray.length; i++) {
          if (selectData[j]&&selectData[j].id == selectedArray[i]) {
            this.$set(selectData[j], 'disabled', true);
          }
        }
      }
    },
    add(data) {
      this.addForm.index = this.addForm.index + 1;
      this.addForm.typeName = data[0].typeName;
      data.push(Object.assign({}, this.addForm));
    },
    //
    remove(data, index, option, optionValueData) {
      let tagIndex;
      //找到删除下标
      for (let i = 0; i < data.length; i++) {
        if (data[i].index == index) {
          tagIndex = i;
        }
      }
      //判断数组大小，删除下拉框的禁用
      if (data.length > 1) {
        data.splice(tagIndex, 1);
        option.forEach((item) => {
          if (item.id == optionValueData) {
            item.disabled = false;
          }
        });
      }
    },
    //（保存）提交
    async submit() {
      let flag1 ,flag2 ,flag3
      this.$refs[this.refList[0]].validate((valid) => {
          if (valid) {
            flag1 = true;
          } else {
            flag1 = false;
          }
        });
        this.$refs[this.refList[1]].validate((valid) => {
          if (valid) {
            flag2 = true;
          } else {
            flag2 = false;
          }
        });
        this.$refs[this.refList[2]].validate((valid) => {
          if (valid) {
            flag3 = true;
          } else {
            flag3 = false;
          }
        });
      this.validateFlag = flag1&&flag2&&flag3 ? true:false
      if (this.validateFlag) {
        await saveValueTarget(
          Object.assign(
            {
              annuals: [...this.costData, ...this.revenueData],
              id: this.editDetailInfo.id,
              projectId: this.editDetailInfo.projectId,
            },
            this.form
          )
        ).then((data) => {
          if (data.code == 200) {
            this.$message({
              showClose: true,
              message: '数据保存成功',
              type: 'success',
            });
            this.validateFlag = true; 
            return true
          } else {
            this.validateFlag = false;
            return false
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: '请将数据填写完整',
          type: 'error',
        });
        return this.validateFlag = false;
      }
       return this.validateFlag;
    },
  },
};
</script>
<style  scoped>
.btn {
  width: 100%;
  border: none;
  height: 30px;
  background: #409eff;
  font-size: 25px;
  color: #fff;
  line-height: 30px;
}
.btn::after {
  display: none;
}
.table1 {
  width: 100%;
  margin: 20px auto;
}
.block {
  height: 6px;
}
::v-deep .demo-only .el-form-item {
 display: flex
}
</style>



